import React, {Component, ReactNode} from 'react'
import {NumberPlate} from "@App/types";

type NumberPlateInputProps = {
    value?: NumberPlate
    validationMessage?: string
    onChange: (event: NumberPlate) => void
    onBlur?: () => void
    showNumberPlateSyncMessage?: boolean
}

type NumberPlateInputState = {
    numberPlate: NumberPlate
}

export class NumberPlateInput extends Component<NumberPlateInputProps, NumberPlateInputState> {

    private firstRef: React.RefObject<HTMLInputElement>;
    private secondRef: React.RefObject<HTMLInputElement>;

    constructor(props: NumberPlateInputProps) {
        super(props)
        this.firstRef = React.createRef()
        this.secondRef = React.createRef()
        this.state = {
            numberPlate: {
                region: props.value ? props.value.region : '',
                firstID: props.value ? props.value.firstID : '',
                secondID: props.value ? props.value.secondID : ''
            }
        }
    }

    onChange = async (event) => {
        const numberPlate = {...this.state.numberPlate}
        numberPlate[event.target.name] = this.formatInput(event)
        await this.setState({numberPlate})

        this.props.onChange(this.state.numberPlate);
    }

    formatInput = (event) => {
        let result = this.state.numberPlate[event.target.name]

        if (event.target.name === 'region') {
            const re = /^[a-zA-ZäöüÄÖÜß\b]+$/
            if (event.target.value === '' || re.test(event.target.value)) {
                result = event.target.value.toUpperCase()
            }
        } else if (event.target.name === 'firstID') {
            const re = /^[a-zA-ZäöüÄÖÜß\b]+$/
            if (event.target.value === '' || re.test(event.target.value)) {
                result = event.target.value.toUpperCase()
            }
        } else if (event.target.name === 'secondID') {
            const re = /^[0-9]{1,4}[eE]?$/
            if (event.target.value === '' || re.test(event.target.value)) {
                result = event.target.value.toUpperCase()
            }
        }

        if (event.target.name === 'region' && event.target.value.length === 3) {
            this.firstRef.current.focus()
        } else if (event.target.name === 'firstID' && event.target.value.length === 2) {
            this.secondRef.current.focus()
        }
        return result
    }

    render(): ReactNode {
        return (
            <>
                <div className={'block md:flex gap-3 items-center'}>
                    <div
                        className="grid grid-cols-10 gap-2 w-full md:w-full items-center bg-white border border-neutral-500 rounded-lg h-16 p-2 my-2">
                        <input type="text"
                               className="text-center text-[35px] leading-none col-span-3 border-0 border-b border-neutral-500"
                               data-testid="region"
                               name="region"
                               placeholder="A"
                               value={this.state.numberPlate.region}
                               onChange={this.onChange}
                               maxLength={3}/>
                        <div className="col-span-1 flex flex-col gap-1 mx-auto">
                            <span className="w-5 h-5 rounded-xl bg-neutral-100 mx-auto"/>
                            <span className="w-6 h-6 rounded-xl bg-neutral-100"/>
                        </div>
                        <input type="text"
                               className="text-center text-[35px] leading-none col-span-2 border-0 border-b border-neutral-500"
                               name="firstID"
                               placeholder="BC"
                               data-testid="firstID"
                               value={this.state.numberPlate.firstID}
                               onChange={this.onChange}
                               ref={this.firstRef}
                               maxLength={2}/>
                        <input type="text"
                               className="text-center text-[35px] leading-none col-span-4 border-0 border-b border-neutral-500"
                               name="secondID"
                               placeholder="1234"
                               data-testid="secondID"
                               value={this.state.numberPlate.secondID}
                               onChange={this.onChange}
                               onBlur={() => this.props.onBlur}
                               ref={this.secondRef}
                               maxLength={5}/>
                    </div>
                    {!!this.props.showNumberPlateSyncMessage && (
                        <div className={'w-full md:w-80 text-sm'}>
                            <p>Ihre Fahrzeugdaten werden automatisch anhand des Kennzeichens an die Werkstatt
                                übermittelt.</p>
                        </div>
                    )}
                </div>
                {this.props.validationMessage && (
                    <div className={'mb-3 text-sm text-error'}>
                        {this.props.validationMessage}
                    </div>
                )}
            </>
        )
    }
}
